import api from '../api/axios';

export const serviceProviderPortalService = {
  // Get current service provider profile
  async getMyProfile() {
    const userId = JSON.parse(localStorage.getItem('user') || '{}').id;
    
    try {
      // Try with filter first (simplified format without $eq)
      const response = await api.get('/service-providers', {
        params: {
          'filters[user][id]': userId,
          populate: '*',
        },
      });
      return response.data;
    } catch (error: any) {
      // If filter fails (400 error), fetch all and filter client-side
      if (error.response?.status === 400) {
        console.warn('Backend filter not supported, fetching all and filtering client-side');
        const allResponse = await api.get('/service-providers', {
          params: {
            populate: '*',
          },
        });
        
        const allProviders = allResponse.data?.data || [];
        const filtered = allProviders.filter((provider: any) => {
          // Handle different response structures
          const providerUser = provider.user?.data || provider.user || provider.attributes?.user?.data || provider.attributes?.user;
          const providerUserId = providerUser?.id || providerUser;
          return providerUserId === userId;
        });
        
        return {
          data: filtered,
          meta: allResponse.data?.meta,
        };
      }
      // Re-throw other errors
      throw error;
    }
  },

  // Get my assigned requests
  async getMyRequests(params?: any) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const profileResponse = await this.getMyProfile();
    const providerId = profileResponse.data?.[0]?.id;
    
    if (!providerId) {
      throw new Error('Service provider profile not found');
    }

    return api.get('/requests', {
      params: {
        ...params,
        'filters[serviceProvider][id][$eq]': providerId,
        populate: {
          insuranceClient: { populate: '*' },
          invoice: { populate: '*' },
        },
      },
    });
  },

  // Accept a request (change status to active)
  async acceptRequest(requestId: number) {
    return api.put(`/requests/${requestId}`, {
      data: {
        status: 'active'
      }
    });
  },

  // Reject a request (change status back to pending and remove assignment)
  async rejectRequest(requestId: number, reason?: string) {
    return api.put(`/requests/${requestId}`, {
      data: {
        status: 'pending',
        serviceProvider: null,
        previousServiceProvider: null,
        providerChangeReason: reason || 'Rejected by service provider'
      }
    });
  },

  // Confirm payment received
  async confirmPayment(requestId: number) {
    return api.put(`/requests/${requestId}`, {
      data: {
        status: 'payment_received',
        paymentReceivedAt: new Date().toISOString()
      }
    });
  },
};

